import { apiBaseUrl } from '../../config'
import store from '../../store'

// getters
const getters = {
  user: state => state,
  isAuthenticated: state => state.token !== '',
  users: state => state.users,
  tenants: state => state.tenants
}

const actions = {
  loginUser(context, credential) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/account/login`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(credential)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        console.log(data)
        context.commit('loginUser', data)
        resolve()
      }).catch(e => {
        context.commit('logoutUser')
        reject()
      });
    })
  },
  logoutUser(context) {
    context.commit('logoutUser')
  },
  resetPassword(context, email) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/account/resetPassword`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({email})
      }).then(res => {
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  createUser(context, data) {
    return new Promise((resolve, reject) => {
      if (data.projectId === undefined) {
        data.projectId = store.state.project.project.id ? store.state.project.project.id : ""
      }
      fetch(`${apiBaseUrl}/account/register`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('createUser', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  saveUser(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/users?token=${store.state.user.token}`, {
        method: "put",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(data)
      }).then(() => {
        context.commit('saveUser', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  deleteUser(context, user) {
    return new Promise((resolve, reject) => {
      fetch(`${apiBaseUrl}/api/users?token=${store.state.user.token}`, {
        method: "delete",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(user)
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('deleteUser', data)
        resolve()
      }).catch(e => {
        console.error(e)
        reject()
      });
    })
  },
  changePassword(context, data) {
    return new Promise((resolve, reject) => {
      const token = data.token !== undefined && data.token !== '' ? data.token : store.state.user.token;
      fetch(`${apiBaseUrl}/account/changePassword?token=${token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({password: data.password})
      }).then(res => {
        return res.json()
      }).then(function(data) {
        console.log(data);
        context.commit('loginUser', data)
        resolve()
      }).catch(e => {
        context.commit('logoutUser')
        reject()
      });
    })
  },
  updateColorScheme(context, data) {
    return new Promise((resolve, reject) => {
      const token = data.token !== undefined && data.token !== '' ? data.token : store.state.user.token;
      fetch(`${apiBaseUrl}/api/tenant/updateColorSchemes?token=${token}`, {
        method: "post",
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify({colorSchemes: data})
      }).then(res => {
        return res.json()
      }).then(function() {
        context.commit('updateColorScheme', data)
        resolve()
      }).catch(e => {
        reject()
      });
    })
  },
  loadUsers(context) {
    return new Promise((resolve, reject) => {
      const token = store.state.user.token;
      fetch(`${apiBaseUrl}/api/users?token=${token}`, {
        method: "get",
        headers: {
          "Content-type": "application/json"
        },
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('loadUsers', data)
        resolve()
      }).catch(e => {
        reject()
      })
    })
  },
  loadTenants(context) {
    return new Promise((resolve, reject) => {
      const token = store.state.user.token;
      fetch(`${apiBaseUrl}/api/tenants?token=${token}`, {
        method: "get",
        headers: {
          "Content-type": "application/json"
        },
      }).then(res => {
        return res.json()
      }).then(function(data) {
        context.commit('loadTenants', data)
        resolve()
      }).catch(e => {
        reject()
      })
    })
  }
}

const mutations = {
  loginUser(state, user) {
    Object.assign(state, user)
  },
  logoutUser(state) {
    Object.assign(state, initializeState())
  },
  updateColorScheme(state, colorSchemes) {
    Object.assign(state.colorSchemes, colorSchemes)
  },
  loadUsers(state, users) {
    state.users = users
  },
  loadTenants(state, tenants) {
    Object.assign(state.tenants, tenants)
  },
  createUser(state, user) {
    state.users.unshift(user);
  },
  deleteUser(state, users) {
    state.users = users
  },
  saveUser(state, user) {
    // project.edit = false
    // project.visible = false
    // Object.assign(state.project, project)
    state.users.map(a => {
      if (a.id === user.id) {
        Object.assign(a, user)
      }
    });
  }
}
export default {
  state: initializeState(),
  mutations,
  actions,
  getters
}

function initializeState() {
  return {
      name: '',
      password: '',
      email: [],
      admin: false,
      token: '',
      themes: [],
      customComponents: [],
      colorSchemes: {},
      users: [],
      tenants: []
  }
}
